var _rect, _rect2, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSms(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 53,
    viewBox: "0 0 53 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 0.75,
    width: 51.5,
    height: 51.5,
    rx: 25.75,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 0.75,
    width: 51.5,
    height: 51.5,
    rx: 25.75,
    stroke: "#FF9012",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36 21.9297V27.9297C36 29.4297 35.5 30.6797 34.62 31.5597C33.75 32.4297 32.5 32.9297 31 32.9297V35.0597C31 35.8597 30.11 36.3397 29.45 35.8997L25 32.9297H22.88C22.96 32.6297 23 32.3197 23 31.9997C23 30.9797 22.61 30.0397 21.97 29.3297C21.25 28.5097 20.18 27.9997 19 27.9997C17.88 27.9997 16.86 28.4597 16.13 29.2097C16.04 28.8097 16 28.3797 16 27.9297V21.9297C16 18.9297 18 16.9297 21 16.9297H31C34 16.9297 36 18.9297 36 21.9297Z",
    stroke: "#FF9012",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23 32C23 32.32 22.96 32.63 22.88 32.93C22.79 33.33 22.63 33.72 22.42 34.06C21.73 35.22 20.46 36 19 36C17.97 36 17.04 35.61 16.34 34.97C16.04 34.71 15.78 34.4 15.58 34.06C15.21 33.46 15 32.75 15 32C15 30.92 15.43 29.93 16.13 29.21C16.86 28.46 17.88 28 19 28C20.18 28 21.25 28.51 21.97 29.33C22.61 30.04 23 30.98 23 32Z",
    stroke: "#FF9012",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.49 31.9795H17.51",
    stroke: "#FF9012",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19 30.5195V33.5095",
    stroke: "#FF9012",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 25H29.5",
    stroke: "#FF9012",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSms);
export default __webpack_public_path__ + "static/media/iconSMS.72c9de3a42de1766e35a7ab051cc1d4b.svg";
export { ForwardRef as ReactComponent };